export function camelCase(name) {
  return name.charAt(0).toUpperCase() +
    name.slice(1).replace(/-(\w)/g, (m, n) => {
      return n.toUpperCase();
    });
}

export function lineSplit(name) {
  return name.replace(/[A-Z]/g, (m, n) => {
    return '-' + m.toLowerCase();
  });
}

export function isEmpty(value){
  return typeof value === 'undefined' || value === null || value === '';
}
